"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M12 20c1.47 0 2.83-.45 3.95-1.22L6.22 9.05C5.45 10.17 5 11.53 5 13c0 3.87 3.13 7 7 7m0-14c-.94 0-1.83.19-2.65.52L11 8.17V8h2v2.17l5.48 5.48c.33-.82.52-1.71.52-2.65 0-3.87-3.13-7-7-7",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M9 1h6v2H9zm3 5c3.87 0 7 3.13 7 7 0 .94-.19 1.83-.52 2.65l1.5 1.5C20.63 15.91 21 14.5 21 13c0-2.12-.74-4.07-1.97-5.61l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42C16.07 4.74 14.12 4 12 4c-1.5 0-2.91.37-4.15 1.02l1.5 1.5C10.17 6.19 11.06 6 12 6"
}, "1"), /*#__PURE__*/_jsx("path", {
  d: "M11 8v.17l2 2V8zM2.81 2.81 1.39 4.22l3.4 3.4C3.67 9.12 3 10.98 3 13c0 4.97 4.02 9 9 9 2.02 0 3.88-.67 5.38-1.79l2.4 2.4 1.41-1.41zM12 20c-3.87 0-7-3.13-7-7 0-1.47.45-2.83 1.22-3.95l9.73 9.73C14.83 19.55 13.47 20 12 20"
}, "2")], 'TimerOffTwoTone');